import { Component, LOCALE_ID, OnInit } from '@angular/core';
import {ConversationalUIModule,CommandExecuteEvent,Message,PromptCommand, PromptOutput,PromptRequestEvent, SendMessageEvent,User, ExecuteActionEvent,} from '@progress/kendo-angular-conversational-ui';
import {SVGIcon,bellIcon,eyeIcon,infoCircleIcon,questionCircleIcon,warningCircleIcon,xIcon,} from '@progress/kendo-svg-icons';
import { from, merge, Observable, of, Subject } from 'rxjs';
import { ChatService } from '../../services/chatBotService/chat.service';
import { map, scan, tap } from 'rxjs/operators';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { registerLocaleData } from '@angular/common';
import localeIt from '@angular/common/locales/it'; 
import { LocalizationService } from '@progress/kendo-angular-l10n';
import { marked } from 'marked';
import { logicOperators } from '@progress/kendo-angular-filter/util';
import { AutomatedResponse } from '../../services/chatBotService/chat.service';

// Registriamo il locale italiano
registerLocaleData(localeIt);

@Component({
    selector: 'app-drake-bot',
    standalone: true,
    imports: [
        ConversationalUIModule,
        CommonModule,
        MatButtonModule,
        MatIconModule,
        MatTooltipModule,
    ],
    providers: [
        ChatService,
        { provide: LOCALE_ID, useValue: 'it' },
        LocalizationService, // Aggiungiamo il LocalizationService
    ],
    templateUrl: './drake-bot.component.html',
    styleUrls: ['./drake-bot.component.scss'],
})
export class DrakeBotComponent implements OnInit {
    ngOnInit(): void {
      // Chiama la funzione e osserva il log
      this.chatService.getResponses().subscribe(
        (data) => {
          console.log('Dati ricevuti nel componente:', data);  // Log dei dati ricevuti nel componente
        },
        (error) => {
          console.error('Errore nel componente:', error);  // Log degli errori nel componente
        }
      );
    }

    opened = false;
    public closeIcon: SVGIcon = xIcon;
    public eye: SVGIcon = eyeIcon;
    public feed: Observable<Message[]>;

    public today: Date = new Date();

    public readonly user: User = {id: 1,};
    public readonly bot: User = {id: 0,};

    public promptOutputs: PromptOutput[] = [];
    public activeView: number = 0;
    public idCounter = 0;
    private local: Subject<Message> = new Subject<Message>();

    constructor(private chatService: ChatService) {
      // Messaggio iniziale di benvenuto con le risposte suggerite
      const hello: Message = {
        author: this.bot,
        text: 'Ciao, come posso aiutarti?',
        //type: 'reply',
        timestamp: new Date(),
        suggestedActions: [
          { type: 'reply', value: 'Info Drake'},
          { type: 'reply', value: 'Trova luogo' },
        ],
      };
      
      this.feed = merge(of(hello), this.local, this.chatService.responses.pipe()
      ).pipe(
        scan((acc: Message[], x: Message) => {
          console.log('Before scan - acc:', acc);  
          console.log('Incoming message - x:', x); 
          const updatedAcc = [...acc, x];
          console.log('After scan - updated acc:', updatedAcc); 
          return updatedAcc;
        }, [])
      );
      console.log();
    }

    //
    public async onAction(e: ExecuteActionEvent): Promise<void> {
      console.log('Ecco il messaggissimo:', e);
      
      // Invia il messaggio locale
      this.local.next({   
          author: this.user,
          text: e.action.value
      });
  
      // Se il tipo dell'azione è 'reply', chiamare automatedResponse
      if (e.action.type === 'reply') {
          try {
              // Usa await per ottenere la risposta automatica
              const response = await this.chatService.automatedResponse(e.action.value);
              console.log('Risposta automatica:', response);
              
              // Invia la risposta automatica come messaggio locale
              this.local.next({
                  author: this.bot,
                  text: response.response,  
                  //type: response.type,  
                  suggestedActions: response.suggestedActions.map((action: any) => ({
                      type: action.type,
                      value: action.response
                  })),
                  timestamp: new Date(),
              });
          } catch (error) {
              console.error('Errore durante la risposta automatica:', error);
          }
      } else {
          // Se non è un tipo 'reply', invia il messaggio tramite submit
          this.chatService.submit(e.action.value);
      }
  }
  

    public sendMessage(e: SendMessageEvent): void {
     /*this.local.next(e.message);
      console.log('ecco il messaggissimo;', e);
  
      this.local.next({
          author: this.bot,
          typing: true,
      });
      
      this.chatService.submit(e.message.text);*/
    }
  

    public renderMarkdown(md: string): string {
        return marked(md) as string;
    }


























    /*-------------------------------------------------------------------------------------------------------------*/
    //Functions commented out for now (not used in the current version)
    /*-------------------------------------------------------------------------------------------------------------*/

    /*
  public onPromptRequest(ev: PromptRequestEvent): void {
    if (!ev.prompt) {
      return;
    }
    this.createPromptOutput(ev);
    this.activeView = 1;
  }
  
  public onCommandExecute(ev: CommandExecuteEvent): void {
    this.createPromptOutput(ev);
    this.activeView = 1;
  }
  
  private createPromptOutput(
    ev: PromptRequestEvent | CommandExecuteEvent
  ): void {
    this.idCounter += 1;
    const newOutput = {
      title: ev.isRetry ? 'Retry test title' : 'Test title',
      id: this.idCounter,
      prompt: (ev as PromptRequestEvent).prompt
      ? (ev as PromptRequestEvent).prompt
      : (ev as CommandExecuteEvent).command.text,
      output: 'Test content',
      isRetry: ev.isRetry,
      commandId: (ev as PromptRequestEvent).prompt
      ? null
      : (ev as CommandExecuteEvent).command.id,
    };
    this.promptOutputs.unshift(newOutput);
  }

  close(): void {
    this.opened = false;
  }
}

  public commands: PromptCommand[] = [
   {
     text: 'Command text 1',
     id: 0,
     icon: 'bell',
     svgIcon: bellIcon,
   },
   {
     text: 'Command text 2',
     id: 1,
     icon: 'info',
     svgIcon: infoCircleIcon,
   },
   {
     text: 'Command text 3',
     id: 2,
     icon: 'question',
     svgIcon: questionCircleIcon,
   },
   {
     text: 'Command text 4',
     id: 3,
     icon: 'warning',
     svgIcon: warningCircleIcon,
   },
 ];

 public suggestions: string[] = ['Suggestion 1', 'Suggestion 2'];*/
}
